import api from "../_app/api";
import { Contact, GetContactsResponse } from "./types";
import { contactTypesMap } from "./utils";

export const getContactById = async (accountId: string, contactId: string) => {
  const { data }: { data: Contact } = await api({
    method: "GET",
    url: "/contacts/" + contactId,
    params: { "account-id": accountId },
  });
  return parseContact(data);
};

export const getContacts = async (accountId: string, page: number, limit: number) => {
  let { data }: { data: GetContactsResponse } = await api({
    method: "GET",
    url: "/contacts",
    params: {
      "account-id": accountId,
      page,
      size: limit,
    },
  });
  data?.list?.map(parseContact);
  return data;
};

export const createContact = async (accountId: string, contact: Contact) => {
  const { data }: { data: Contact } = await api({
    method: "POST",
    url: "/contacts",
    params: { "account-id": accountId },
    data: {
      ...contact,
    },
  });
  return parseContact(data);
};

export const updateContact = async (accountId: string, contact: Contact) => {
  const { data }: { data: Contact } = await api({
    method: "PUT",
    url: `/contacts/${contact?.id}`,
    params: { "account-id": accountId },
    data: {
      ...contact,
      typeFriendly: undefined,
    },
  });
  return parseContact(data);
};

export const deleteContact = async (accountId: string, contact: Contact) => {
  const { data }: { data: Contact } = await api({
    method: "DELETE",
    url: `/contacts/${contact?.id}`,
    params: { "account-id": accountId },
  });
  return parseContact(data);
};

export const parseContact = (contact: Contact) => {
  contact.typeFriendly = contactTypesMap[contact.type];
  return contact;
};
